import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SharedSvgModule } from '@warema/shared/svg';
import { ErrorScreenContent } from '@warema/warema-plus/models';
import { WaremaButton } from '@warema/warema-ui-angular';

@Component({
    selector: 'warema-error-screen',
    templateUrl: './error-screen.component.html',
    styleUrls: ['./error-screen.component.scss'],
    imports: [TranslatePipe, WaremaButton, SharedSvgModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorScreenComponent implements OnInit {
    private readonly _location = inject(Location);

    public errorScreenContent!: ErrorScreenContent;

    public ngOnInit(): void {
        this.errorScreenContent = history.state as ErrorScreenContent;
    }

    public goBack(): void {
        this._location.back();
    }
}
